import Vue from "vue";
import VueRouter from "vue-router";
import Main from "../views/Main";
import VueMeta from "vue-meta";
import Store from "../store";

Vue.use(VueRouter);
Vue.use(VueMeta);

const routes = [
  {
    path: "/",
    name: "Main",
    component: Main
  },
  {
    path: "/location",
    name: "SetLocation",
    component: () =>
      import(
        /* webpackChunkName: "SetLocation" */ "../views/delivery/SetLocation"
      )
  },
  {
    path: "/my-location",
    name: "my-location",
    component: () =>
      import(
        /* webpackChunkName: "mylocation" */ "../views/delivery/MyLocation"
      )
  },
  {
    path: "/inactive-instance",
    name: "InactiveInstance",
    component: () =>
      import(
        /* webpackChunkName: "InactiveInstance" */ "../views/InactiveInstance.vue"
      )
  },
  {
    path: "/branch-to-on-table",
    name: "BranchOnTable",
    component: () =>
      import(/* webpackChunkName: "branchOnTable" */ "../views/BranchOnTable")
  },
  {
    path: "/branch-to-take-away",
    name: "BranchToTakeAway",
    component: () =>
      import(
        /* webpackChunkName: "branchToTakeAway" */ "../views/BranchToTakeAway"
      )
  },
  {
    path: "/branch-without-service",
    name: "BranchWithOutService",
    component: () =>
      import(
        /* webpackChunkName: "branchWithOutService" */ "../views/BranchWithOutService"
      )
  },
  {
    path: "/branch-to-book",
    name: "BranchToBook",
    component: () =>
      import(/* webpackChunkName: "branchToBook" */ "../views/BranchToBook")
  },
  {
    path: "/branch-offices",
    name: "Branch",
    component: () => import(/* webpackChunkName: "branch" */ "../views/Branch")
  },
  {
    path: "/branch-whatsapp",
    name: "BranchWhatsapp",
    component: () =>
      import(/* webpackChunkName: "branchWhatsapp" */ "../views/BranchWhatsapp")
  },
  {
    path: "/ratecluvi/:purchase_id/:token",
    name: "Rate",
    component: () => import(/* webpackChunkName: "rate" */ "../views/Rate")
  },
  {
    path: "/reservarpopup/:branch_id",
    name: "bookPopup",
    component: () =>
      import(
        /* webpackChunkName: "bookCreatePopup" */ "../views/book/BookCreatePopup"
      )
  },
  {
    path: "/:supplier_id",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/delivery/Home")
  },
  {
    path: "/:supplier_id/precheckout",
    name: "Precheckout",
    component: () =>
      import(/* webpackChunkName: "precheckout" */ "../views/Precheckout")
  },
  {
    path: "/:supplier_id/checkout/:id",
    name: "Checkoutv2",
    component: () =>
      import(/* webpackChunkName: "checkout" */ "../views/Checkout")
  },
  {
    path: "/:supplier_id/webcheckout/:order_id",
    name: "Webcheckout",
    component: () =>
      import(/* webpackChunkName: "webcheckout" */ "../views/Webcheckout")
  },
  {
    path: "/:supplier_id/menu-digital",
    name: "OnTableMenuDigital",
    requiresAuth: false,
    component: () =>
      import(
        /* webpackChunkName: "onTableMenuDigital" */ /* webpackPrefetch: true */ "../views/on_table/MenuDigital.vue"
      )
  },
  {
    path: "/:supplier_id/grab-and-go",
    name: "OnTableMenuDigital",
    component: () =>
      import(
        /* webpackChunkName: "onTableMenuDigital" */ /* webpackPrefetch: true */ "../views/on_table/MenuDigital.vue"
      )
  },
  {
    path: "/:supplier_id/menu-digital/home",
    name: "OnTableHome",
    component: () =>
      import(
        /* webpackChunkName: "onTableMenuDigital" */ /* webpackPrefetch: true */ "../views/on_table/Home"
      )
  },
  {
    path: "/:supplier_id/menu-digital/newhome",
    name: "OnTableNewHome",
    component: () =>
      import(
        /* webpackChunkName: "onTableMenuDigital" */ /* webpackPrefetch: true */ "../views/on_table/NewHome"
      )
  },
  {
    path: "/:supplier_id/solo-pago",
    name: "OnTableHome",
    component: () =>
      import(
        /* webpackChunkName: "onTableMenuDigital" */ /* webpackPrefetch: true */ "../views/on_table/Home"
      )
  },
  {
    path: "/:supplier_id/menu-digital/my-order/:purchase_id",
    name: "MyOrder",
    component: () =>
      import(
        /* webpackChunkName: "onTableMenuDigital" */ "../views/on_table/MyOrder.vue"
      )
  },
  {
    path: "/:supplier_id/grab-and-go/my-order",
    name: "MyOrder",
    component: () =>
      import(
        /* webpackChunkName: "onTableMenuDigital" */ "../views/on_table/MyOrder.vue"
      )
  },
  {
    path: "/:supplier_id/delivery/order",
    name: "DeliveryCartInProgress",
    component: () =>
      import(
        /* webpackChunkName: "deliveryOrder" */ "../views/delivery/CartInProgress"
      )
  },
  {
    path: "/:supplier_id/maincategories",
    name: "MainCategories",
    component: () =>
      import(
        /* webpackChunkName: "menuMainCategories" */ /* webpackPrefetch: true */ "../views/MenuMainCategories.vue"
      )
  },
  {
    path: "/:supplier_id/subcategories",
    name: "SubCategories",
    component: () =>
      import(
        /* webpackChunkName: "menuSubCategories" */ "../views/MenuSubCategories.vue"
      )
  },
  {
    path: "/:supplier_id/service-room",
    name: "ServiceRoom",
    component: () =>
      import(/* webpackChunkName: "serviceRoom" */ "../views/ServiceRoom")
  },
  {
    path: "/:supplier_id/md",
    name: "MenuDigitalShort",
    component: () =>
      import(
        /* webpackChunkName: "menuDigitalShort" */ "../views/MenuDigitalShort"
      )
  },
  {
    path: "/:supplier_id/delivery",
    name: "Delivery",
    component: () =>
      import(
        /* webpackChunkName: "DeliveryRedirect" */ "../views/DeliveryRedirect"
      )
  },
  {
    path: "/:supplier_id/location",
    name: "DeliveryLocation",
    component: () =>
      import(
        /* webpackChunkName: "DeliveryRedirect" */ "../views/DeliveryRedirect"
      )
  },
  {
    path: "/:supplier_id/reservar",
    name: "Book",
    component: () =>
      import(/* webpackChunkName: "book" */ "../views/book/BookCreateRefactor")
  },
  {
    path: "/:supplier_id/orders",
    name: "Orders",
    component: () =>
      import(/* webpackChunkName: "orders" */ "../views/Orders.vue")
  },
  {
    path: "/:supplier_id/order/:order_id",
    name: "Order",
    component: () =>
      import(/* webpackChunkName: "order" */ "../views/Order.vue")
  },
  {
    path: "/:supplier_id/politicas-servicio",
    name: "ServicePolicies",
    component: () =>
      import(
        /* webpackChunkName: "servicePolicies" */ "../views/ServicePolicies"
      )
  },
  {
    path: "/:supplier_id/view/:product_id",
    name: "ProductView",
    component: () =>
      import(
        /* webpackChunkName: "routeProduct" */ "../views/product/RouteProduct.vue"
      )
  },
  {
    path: "/:supplier_id/:product_id",
    name: "Product",
    component: () =>
      import(
        /* webpackChunkName: "routeProduct" */ "../views/product/RouteProduct.vue"
      )
  },
  {
    path: "/:supplier_id/sl/:profile_id/:token",
    name: "Smartlink",
    component: () =>
      import(/* webpackChunkName: "smartlink" */ "../views/Smartlink.vue")
  },
  {
    path: "/:supplier_id/sl/:profile_id/:token/:purchase_id",
    name: "SmartlinkToPurchase",
    component: () =>
      import(
        /* webpackChunkName: "smartlinkToPurchase" */ "../views/Smartlink.vue"
      )
  },
  {
    path: "/book_info/:id/:token",
    name: "BookInfo",
    component: () =>
      import(
        /* webpackChunkName: "bookingDetail" */ "../views/book/BookDetail.vue"
      )
  },
  {
    path: "/rate/:id/:token",
    name: "BookQualify",
    component: () =>
      import(
        /* webpackChunkName: "qualifyBooking" */ "../views/book/BookQualify.vue"
      )
  },
  {
    path: "/:supplier_id/history-my-orders",
    name: "HistoryMyOrders",
    component: () =>
      import(
        /* webpackChunkName: "historyOrders" */ "../views/on_table/HistoryMyOrders.vue"
      )
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeResolve(async (to, from, next) => {
  let includeRute = [
    "OnTableHome",
    "Menu",
    "MainCategories",
    "SubCategories"
  ].includes(to.name);
  let serviceOntable =
    Store.state.customer.instance.new_menu_v3 &&
    Store.state.customer.supplier.on_table_class === "basic" &&
    Store.getters["order/service"] === "on_table" &&
    Store.getters["order/is_ontable_service"] &&
    Store.getters["customer/is_ontable_basic"];
  if (includeRute && serviceOntable) {
    let url = window.location.origin;
    let idSupplier = Store.state.customer.supplier.id.toString();
    return window.open(
      url + "/newmenu/" + idSupplier + "/on_table/basic",
      "_self"
    );
  } else {
    next();
  }
});

export default router;
